import React from 'react';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import moment from 'moment';
import { StyledBoxTable } from '../../../../components/layout/main/mainStyles';
import { LoadingRowsComponent } from '../../../../components/commons/LoadingRows/LoadingRows';
import { SearchSerialNumberTemplateTemplateProps } from './searchSerialNumberTemplateProps';

export const SearchSerialNumberTemplate = ({
  isLoading,
  isSuccess,
  allSerialNumber,
  selectedItems,
  setSelectedItems
}: SearchSerialNumberTemplateTemplateProps) => {
  const getFormattedDate = (rowData: { manufacturingDate: string }) => {
    if (rowData.manufacturingDate) {
      return moment(rowData.manufacturingDate).format('MM/DD/YYYY HH:MM');
    }
    return '';
  };
  return (
    <StyledBoxTable>
      {isLoading && <LoadingRowsComponent />}
      {isSuccess && allSerialNumber && (
        <DataTable
          selectionMode="multiple"
          metaKeySelection
          selection={selectedItems}
          value={allSerialNumber ?? []}
          size="small"
          scrollable
          scrollHeight="flex"
          onSelectionChange={(e) => setSelectedItems(e.value)}
          paginator={allSerialNumber && allSerialNumber.length >= 50}
          selectionPageOnly
          rows={50}
          rowsPerPageOptions={[5, 10, 20, 50]}
          tableStyle={{ padding: 0, margin: 0, fontSize: '14px' }}
          className="mt-3"
          rowHover
        >
          <Column field="partNumber.partNumber" header="Part Number" sortable />
          <Column field="partNumber.product" header="Product" sortable />
          <Column field="partNumber.series" header="Series" sortable />
          <Column field="partNumber.model" header="Model" sortable />
          <Column field="partNumber.sku" header="SKU" sortable />
          <Column field="serialNumber" header="Serial Number" sortable />
          <Column
            field="manufacturingDate"
            header="Manufacturing Date"
            sortable
            body={getFormattedDate}
          />
        </DataTable>
      )}
    </StyledBoxTable>
  );
};
